/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Devices_EmptyInputs */

const vi_irrigation_devices_empty = /** @type {(inputs: Irrigation_Devices_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản SmartLab chưa có bộ tưới nào`)
};

/**

* @param {Irrigation_Devices_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_devices_empty = /** @type {((inputs?: Irrigation_Devices_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Devices_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_devices_empty(inputs)
});